export default __webpack_public_path__ + "static/media/sliderCards_noThemeSelected.375086d6.svg";